export const BASE_APP_ROUTE = "/admin";

export const APP_ROUTES = {
  HOME: "/",
  AUTH: "/users/auth",
  INVENTORY: {
    BASE: "/inventory",
    PRODUCT_DETAIL: "/inventory/product/:productId",
    TOPPING: "/topping",
    TOPPING_DETAIL: "/topping/:toppingId",
  },
  BLOG: {
    BASE: "/blog",
    BLOG_DETAIL: "/blog/:code",
  },
  FAQ: {
    BASE: "/faq",
    FAQ_DETAIL: "/faq/:code",
  },
  PROMOTION: {
    BASE: "/promotion",
    PROMOTION_DETAIL: "/promotion/:promotionId",
  },
  AGENT: {
    BASE: "/agent",
    AGENT_DETAIL: "/agent/:agentId",
  },
  DOCUMENT: {
    BASE: "/document",
    DOCUMENT_DETAIL: "/document/:documentId",
  },
  ORDER: {
    BASE: "/order",
    ORDER_DETAIL: "/order/:orderId",
  },
  NOTFOUND: "/notfound",

  PAGEMANAGEMENT: {
    BANNER: {
      BASE: "/banner",
      DETAIL: "/banner/:bannerCode",
    },
    SOLUTION: {
      BASE: "/solution",
      DETAIL: "/solution/:solutionCode",
    },
    NEWS: {
      BASE: "/news",
      DETAIL: "/news/:newsCode",
    },
    TECHNOLOGY: {
      BASE: "/technology",
      DETAIL: "/technology/:technologyCode",
    },
    FOCUSED_MARKET: {
      BASE: "/focused-market",
      DETAIL: "/focused-market/:marketCode",
    },
    NETWORK: {
      BASE: "/network",
      DETAIL: "/network/branch/:branchId",
    },
    CAREER: {
      BASE: "/career",
      DETAIL: "/career/:careerCode",
    },
  },

  RESOURCE: {
    VIDEO: {
      VIDEOHOMEPAGE: {
        BASE: "/videoHomepage",
        DETAIL: "/videoHomepage/:videoCode",
      },
      VIDEORESOURCE: {
        BASE: "/videoResource",
        DETAIL: "/videoResource/:videoCode",
      },
    },
  },
  QUOTATION: {
    BASE: "/quotation",
    QUOTATION_DETAIL: "/quotation/quotation-history/:quotationId",
  },
};
